import UnpublishedNewsStatus from './unpublished-news-status';

export default UnpublishedNewsStatus;
